import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ChatTongole from './components/Chat/ChatTongole';

// Set data-origin on <html> for origin-scoped styling
const originForAttr = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '')
  .replace(/\.(com|live|net|world|bet|buzz|win|pro)$/i, '');
document.documentElement.setAttribute('data-origin', originForAttr);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChatTongole />
    <App />
  </React.StrictMode>
);
